import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * Every list has one, and it always offers the next action rather than
 * apologising (§8.4).
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 rounded-[6px] border border-dashed border-[var(--border)] px-6 py-12 text-center',
        className,
      )}
    >
      {icon ? <div className="text-[var(--text-muted)]">{icon}</div> : null}
      <p className="text-[15px] font-medium">{title}</p>
      {description ? <p className="max-w-[46ch] text-[13px] vt-muted">{description}</p> : null}
      {action ? <div className="pt-1">{action}</div> : null}
    </div>
  );
}
